import { render } from "./Header.vue?vue&type=template&id=94def000&ts=true"
import script from "./Header.vue?vue&type=script&lang=ts"
export * from "./Header.vue?vue&type=script&lang=ts"

import "./Header.vue?vue&type=style&index=0&id=94def000&lang=scss"

import exportComponent from "/var/www/html/devcwmserver.com/taca/client/staging/RACA_FRONTEND/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__